import "./SurveyHistoryButtons.scss";

import { Button, Flex } from "@fluentui/react-northstar";
import React from "react";
import { Link } from "react-router-dom";

import { getPageContext } from "../../../../_shared/utils/teamsHelpers";

interface Props {
  scheduleId: string;
  allowShowResults: boolean;
  onViewResponsesClickHandler: () => void;
  upgradeButton?: React.ReactNode;
}

export const SurveyHistoryButtons: React.FC<Props> = ({
  scheduleId,
  onViewResponsesClickHandler,
  allowShowResults,
  upgradeButton,
}) => {
  return (
    <Flex gap="gap.smaller" className="standup-card__footer" hAlign="end" space="around">
      <Flex.Item>
        <>
          {upgradeButton ? (
            upgradeButton
          ) : (
            <Button
              onClick={onViewResponsesClickHandler}
              className="survey-history-buttons__current-responses"
              primary
              content="Current responses"
              disabled={!allowShowResults}
            />
          )}
        </>
      </Flex.Item>
      <Flex.Item>
        <Button
          className="survey-history-buttons__historical-responses"
          to={`${getPageContext()}/content/polly/series/${scheduleId}`}
          as={Link}
          primary
          content="Historical responses"
          disabled={!allowShowResults}
        />
      </Flex.Item>
    </Flex>
  );
};
